import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { TableChartConfigDto, UmpireGamePerformanceChartDataDto, UmpireGamePerformanceDataDto } from 'types/CodegenReportTypes';
import Table, { Order } from 'components/Table/Table';
import { ChartProps } from 'utilities/chartIdToComponent';
import { getDisplayedColumns, tableHeaders } from 'utilities/tableHeaders';

export type UmpireGamePerformanceChartColumn = keyof UmpireGamePerformanceDataDto;

const UmpireGamePerformanceChart = ({
  chartData,
  isLoading,
  chartConfig,
}: ChartProps<UmpireGamePerformanceChartDataDto, TableChartConfigDto>) => {
  const { t } = useTranslation();

  const [page, setPage] = useState(0);
  const [order, setOrder] = useState<Order>('desc');
  const [orderBy, setOrderBy] = useState<UmpireGamePerformanceChartColumn | '' | 'id'>('');

  const rows = useMemo(
    () =>
      chartData?.umpireGamePerformances.map((row, i) => ({
        ...row,
        id: i.toString(),
      })) ?? [],
    [chartData?.umpireGamePerformances]
  );

  const columns = useMemo(() => {
    const displayedColumns = getDisplayedColumns<UmpireGamePerformanceChartColumn>(chartConfig.visibleStats);

    return displayedColumns.map((column) => ({
      ...tableHeaders[column],
      field: column,
      headerName: t(column),
      headerShortName: t('short.' + column),
      sortable: true,
    }));
  }, [chartConfig.visibleStats]);

  return (
    <Table
      rows={rows}
      pageState={[page, setPage]}
      orderState={[order, setOrder]}
      orderByState={[orderBy, setOrderBy]}
      columns={columns}
      loading={isLoading}
      noFooter
      tileTable
    />
  );
};

export default UmpireGamePerformanceChart;
